var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cover",attrs:{"href":_vm.link,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.imgsrc}}),_c('h3',{staticClass:"title",style:({ fontSize: _vm.fontSize })},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }